export const SAVE_CONTACT_SNAPSHOT = 'SAVE_CONTACT_SNAPSHOT';
export const CLEAR_CONTACT_SNAPSHOT = 'CLEAR_CONTACT_SNAPSHOT';

export const saveContactSnapshot = (contactSnapshot) => ({
    type: SAVE_CONTACT_SNAPSHOT,
    payload: contactSnapshot
});

export const clearContactSnapshot = () => ({ type: CLEAR_CONTACT_SNAPSHOT });